import { handleResponse } from "utils/utils";
import { authService } from "services";

export const chatsService = {
	createForTimeRegistration,
	getById,
	addMessage,
};

function getAuthHeaders() {
	return {
		Authorization: `Bearer ${authService.token.access_token}`,
		"Content-Type": "application/json",
		"X-Geo-IP": global.GetIPHeader,
	};
}

function createForTimeRegistration(timeRegistrationId, body) {
	const requestOptions = {
		method: "POST",
		headers: getAuthHeaders(),
		body: JSON.stringify(body),
	};

	return fetch(
		`${global.BASE_API}chats/time-registrations/${timeRegistrationId}`,
		requestOptions
	).then(handleResponse);
}

function getById(chatId) {
	const requestOptions = {
		method: "GET",
		headers: {
			...getAuthHeaders(),
			"Cache-Control": "no-cache, no-store, must-revalidate",
			Pragma: "no-cache",
		},
		cache: "no-store",
	};

	return fetch(
		`${global.BASE_API}chats/${chatId}?_=${Date.now()}`,
		requestOptions
	).then(handleResponse);
}

function addMessage(chatId, body) {
	const requestOptions = {
		method: "PUT",
		headers: getAuthHeaders(),
		body: JSON.stringify(body),
	};

	return fetch(`${global.BASE_API}chats/${chatId}`, requestOptions).then(
		handleResponse
	);
}
